import React, { useState, useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import HeadingArea from '../../general/HeadingArea';
import Logo from '../../assets/logo.png';
import '../../css/Admin/exam/PrepareReportCard.css';
import ResponseMsg2 from '../../general/ResponseMsg2';
import DefaultImg from '../../assets/default-img.jpg';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';


const PrepareReportCard = ({setLoading}) => {
         const { state } = useLocation();
  const { student } = state;
  const navigate = useNavigate();
//   console.log(state.student);
    const [report, setReport] = useState([]);
    const [examReport, setExamReport] = useState([]);
    const [response2, setResponse2] = useState({ message: '', status: 'success' });
const [currentReportType, setCurrentReportType] = useState('');
const reportRef = useRef();
// Co-Scholastic dynamic rows
const [coSch1, setCoSch1] = useState(
  state.student.cosch_1 
    ? JSON.parse(state.student.cosch_1) 
    : [{ activity: "", grade: "" }]
);

const [coSch2, setCoSch2] = useState(
  state.student.cosch_2 
    ? JSON.parse(state.student.cosch_2) 
    : [{ activity: "", grade: "" }]
);


const handleAddRow1 = () => {
  setCoSch1([...coSch1, { activity: "", grade: "" }]);
};

const handleAddRow2 = () => {
  setCoSch2([...coSch2, { activity: "", grade: "" }]);
};

const handleChange1 = (index, field, value) => {
  const updated = [...coSch1];
  updated[index][field] = value;
  setCoSch1(updated);
};

const handleChange2 = (index, field, value) => {
  const updated = [...coSch2];
  updated[index][field] = value;
  setCoSch2(updated);
};


const updateCoScholastic = async () => {
  try {
    const body = {
      student_id: state.student.id,
      cosch_1: JSON.stringify(coSch1),
      cosch_2: JSON.stringify(coSch2)
    };

    const response = await fetch("https://api.kcian.in/update-coscholastic", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    });

    if (response.ok) {
      setResponse2({ message: "Co-Scholastic Grades Updated", status: "success" });
    } else {
      setResponse2({ message: "Failed to Update", status: "error" });
    }
  } catch (e) {
    setResponse2({ message: "Error Updating", status: "error" });
  }
  setTimeout(() => setResponse2({ message: "", status: "" }), 2000);
};



useEffect(() => {
handleSearch();
}, [state.student])

      const handleSearch = async () => {
        setLoading(true);

        try {
            // Build query params
            const params = new URLSearchParams();
            params.append('ay', state.student.ay);
            params.append('class_name', state.student.class_name);
            params.append('section', state.student.section);
            params.append('student_id', state.student.id);

            const url = `https://api.kcian.in/get-mystdatd-report?${params.toString()}`;

            const response = await fetch(url);

            if (response.ok) {
                const data = await response.json();
                console.log(data);
                setReport(data);
            } else {
                console.error('Failed to fetch students atd report');
            }
        } catch (error) {
            console.error('Error fetching students atd report:', error);
        } finally {
            setLoading(false);
        }
    };


    const presentCount = report.filter(r => r.mark == "Present").length;
const absentCount = report.filter(r => r.mark == "Absent").length;
const leaveCount = report.filter(r => r.mark == "Leave").length;
const holidayCount = report.filter(r => r.mark == "Holiday").length;

const totalDays = presentCount + absentCount + leaveCount + holidayCount;
const attendancePercent = totalDays > 0 
  ? (((presentCount + holidayCount) / totalDays) * 100).toFixed(2)
  : 0;


  const handleExamReport = async (studentId, reportType) => {
  setLoading(true);
  setCurrentReportType(reportType);

  try {
    const params = new URLSearchParams();
    params.append('student_id', studentId);
    params.append('year', state.student.ay);
    params.append('report_type', reportType);

    const url = `https://api.kcian.in/get-exam-report?${params.toString()}`;
    
    const response = await fetch(url);

    if (response.ok) {
      const data = await response.json();
      setExamReport(data);
      console.log(`${reportType} Report Data:`, data);
              setResponse2({ message: 'Exam Report Found.', status: 'success' });
    } else {
              setResponse2({ message: 'Something went Wrong.', status: 'error' });
      console.error('Failed to generate report');
    }
  } catch (error) {
    console.error('Error generating report:', error);
  } finally {
            setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    setLoading(false);
  }
};


const examOrder = ['Periodic Test 1', 'Note Book 1', 'Subject Enrichment 1', 'Half Yearly', 'Periodic Test 2', 'Note Book 2', 'Subject Enrichment 2', 'Yearly'];
const uniqueExams = [...new Set(examReport.map(r => r.exam_name))];
// const sortedExams = uniqueExams.sort((a, b) => {
//   const indexA = examOrder.indexOf(a);
//   const indexB = examOrder.indexOf(b);
//   return indexA - indexB;
// });


const getGrade = (marks) => {
  if (marks >= 91) return 'A1';
  if (marks >= 81) return 'A2';
  if (marks >= 71) return 'B1';
  if (marks >= 61) return 'B2';
  if (marks >= 51) return 'C1';
  if (marks >= 41) return 'C2';
  if (marks >= 33) return 'D';
  return 'E';
};

const halfYearExams = ['Periodic Test 1', 'Note Book 1', 'Subject Enrichment 1', 'Half Yearly'];
const yearlyExams = ['Periodic Test 2', 'Note Book 2', 'Subject Enrichment 2', 'Yearly'];


const subjects = [...new Set(examReport.map(r => r.sub_name))];

const subjectSummary = subjects.map(subject => {
  const halfYearMarks = halfYearExams.reduce((sum, examName) => {
    const record = examReport.find(r => r.sub_name === subject && r.exam_name === examName);
    return sum + (record ? Number(record.marks_obtain) : 0);
  }, 0);

  const yearlyMarks = yearlyExams.reduce((sum, examName) => {
    const record = examReport.find(r => r.sub_name === subject && r.exam_name === examName);
    return sum + (record ? Number(record.marks_obtain) : 0);
  }, 0);

  return {
    subject,
    halfYearMarks,
    halfYearGrade: getGrade(halfYearMarks),
    yearlyMarks,
    yearlyGrade: getGrade(yearlyMarks)
  };
});


// Calculate Overall Totals
const overallHalfTotal = examReport
  .filter(r => halfYearExams.includes(r.exam_name))
  .reduce((sum, r) => sum + Number(r.total_marks || 0), 0);

const overallHalfObtained = examReport
  .filter(r => halfYearExams.includes(r.exam_name))
  .reduce((sum, r) => sum + Number(r.marks_obtain || 0), 0);

const overallHalfGrade = getGrade(overallHalfObtained);

// Only calculate yearly if Annual report selected
let overallYearTotal = 0;
let overallYearObtained = 0;
let overallYearGrade = '';

if (currentReportType === 'Annual') {
  overallYearTotal = examReport
    .filter(r => yearlyExams.includes(r.exam_name))
    .reduce((sum, r) => sum + Number(r.total_marks || 0), 0);

  overallYearObtained = examReport
    .filter(r => yearlyExams.includes(r.exam_name))
    .reduce((sum, r) => sum + Number(r.marks_obtain || 0), 0);

  overallYearGrade = getGrade(overallYearObtained);
}


const printReportCard = () => {
  const input = reportRef.current;

  if(currentReportType == ''){
                  setResponse2({ message: 'Fetch Exam Report.', status: 'error' });
            setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    return;
  }

  if (!input) return;

    const elementsToHide = document.querySelectorAll(".hide-class");
  elementsToHide.forEach(el => el.classList.add("print-hide"));


  html2canvas(input, { scale: 1, logging: false }).then(canvas => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'pt', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const imgProps = pdf.getImageProperties(imgData);
    const imgWidth = pdfWidth;
    const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pdfHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;
    }

    pdf.save(`report_card${state.student.admission_no}.pdf`);
  }).catch(err => {
    console.error('Error generating PDF:', err);
  });
};



  return (
    <>
      <section className='py-4'>
        <div className='px-4'>
          <HeadingArea message1='Exam' message2='Prepare Report Card' />

                                                    <button onClick={() => navigate('/admin/offline-report-card')} type='button' className='profile-btn2 me-3'>
                    Go Back
                  </button>

<button className='profile-btn me-3' onClick={() => handleExamReport(state.student.id, 'Half Year')}>Half Year Report</button>
<button className='profile-btn me-3' onClick={() => handleExamReport(state.student.id, 'Annual')}>Fetch Annual Report</button>
  <button className="profile-btn me-3" onClick={updateCoScholastic}>
    Update Co-Scholastic Grades
  </button>

<button className='profile-btn' onClick={printReportCard}>Print Report Card</button>

   {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

<div className='report-card mt-3' ref={reportRef}>

<div className='report-logo-area'>
<img src={Logo} className='report-watermark' alt='Report Logo' /></div>

<div className='d-flex justify-content-between'>
    <div></div>
    <div className='text-center'>
<p className='my-0 profile-heading fs-5 fw-bold'>K. C. Public School</p>
<p>(C.B.S.E. Affiliation No. 1530116)<br />Tata Benz Square, Berhampur</p>
    <p className='fw-bold fs-5 my-0'>Academic Session: {state.student.ay - 1}-{state.student.ay.slice(2,4)}<br />PROGRESS REPORT</p>

</div>
<img src={Logo} className='report-logo' alt='Report Logo' />
</div>
{/* flex header ends */}


<div className='d-flex justify-content-between mt-4'>

<div>
<span className='fw-semibold me-2'>Admission No.</span> : {state.student.admission_no}<br />
<span className='fw-semibold me-2'>Student's Name</span> : {state.student.name}<br />
<span className='fw-semibold me-2'>Father's Name</span> : {state.student.father}<br />
<span className='fw-semibold me-2'>Mother's Name</span> : {state.student.mother}
</div>

<div>
   <span className='fw-semibold me-2'>Class/ Section</span> : {state.student.class_name} {state.student.section}<br /> 
   <span className='fw-semibold me-2'>Roll No.</span> : {state.student.roll_no}<br />
<span className='fw-semibold me-2'>Date of Birth</span> : {state.student.dob && new Date(state.student.dob).toLocaleDateString('en-GB')}
</div>

<img src={state.student.profile_pic || DefaultImg} className='report-logo border' alt='Student Logo' />


</div>
{/* student info ends */}


<div className='table-responsive mt-4'>
    <table className='w-100 table table-bordered border-dark'>

<thead className='para-text fw-semibold text-center'>
    <tr>
        <th>Scholastic Areas</th>
        <th colSpan={6}>Half Yearly Exam (100 marks)</th>
        {currentReportType === 'Annual' && (
        <th colSpan={6}>Yearly Exam (100 marks)</th>)}
    </tr>
</thead>

<thead className='para-text fw-semibold text-center'>
  <tr>
    <th>Sub Name</th>
    {halfYearExams.map((exam, idx) => {
      const record = examReport.find(r => r.exam_name === exam);
      return <th key={idx}>{exam}<br />({record ? record.total_marks : '--'})</th>;
    })}
    <th>Marks Obtained</th>
    <th>Grade</th>

    {currentReportType === 'Annual' && (
      <>
        {yearlyExams.map((exam, idx) => {
          const record = examReport.find(r => r.exam_name === exam);
          return <th key={idx}>{exam}<br />({record ? record.total_marks : '--'})</th>;
        })}
    <th>Marks Obtained</th>
        <th>Grade</th>
      </>
    )}
  </tr>
</thead>


<tbody className='border-dark'>
  {subjectSummary.map((s, idx) => (
    <tr key={idx}>
      <td>{s.subject}</td>
      {halfYearExams.map((exam, jdx) => {
        const record = examReport.find(r => r.sub_name === s.subject && r.exam_name === exam);
        return <td key={jdx}>{record ? record.marks_obtain : '--'}</td>;
      })}
      <td>{s.halfYearMarks}</td>
      <td>{s.halfYearGrade}</td>

      {currentReportType === 'Annual' && (
        <>
          {yearlyExams.map((exam, jdx) => {
            const record = examReport.find(r => r.sub_name === s.subject && r.exam_name === exam);
            return <td key={jdx}>{record ? record.marks_obtain : '--'}</td>;
          })}
          <td>{s.yearlyMarks}</td>
          <td>{s.yearlyGrade}</td>
        </>
      )}
    </tr>
  ))}
  <tr>
    <td className='fw-semibold'>Total</td>
    <td colSpan={4}></td>
<td>{overallHalfObtained}</td>
  <td>{overallHalfGrade}</td>    {currentReportType === 'Annual' && (
        <>
            <td colSpan={4}></td>
 <td>{overallYearObtained}</td>
      <td>{overallYearGrade}</td>        </>
    )}
    </tr>

</tbody>




    </table>
</div>
{/* scholastic area ends */}



<div className='row mt-2'>

<div className='col-md-6 col-12 mt-2'>
  <table className="table table-bordered border-dark">
    <thead className='para-text'>
      <tr>
        <th>Co-Scholastic Areas: Term I</th>
        <th>Grade</th>
      </tr>
    </thead>

    <tbody>
      {coSch1.map((row, i) => (
        <tr key={i}>
          <td>
            <input
              className="profile-input py-0"
              placeholder="Activity (e.g., Work Education)"
              value={row.activity}
              onChange={(e) => handleChange1(i, "activity", e.target.value)}
            />
          </td>

          <td>
            <input
              className="profile-input py-0"
              placeholder="A / B / C"
              value={row.grade}
              onChange={(e) => handleChange1(i, "grade", e.target.value)}
            />
          </td>
        </tr>
      ))}

      <tr className='hide-class'>
        <td colSpan={2} className="text-center">
          <button className='profile-btn2' onClick={handleAddRow1}>
            + Add More
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>


<div className='col-md-6 col-12 mt-2'>
  <table className="table table-bordered border-dark">
    <thead className='para-text'>
      <tr>
        <th>Co-Scholastic Areas: Term II</th>
        <th>Grade</th>
      </tr>
    </thead>

    <tbody>
      {coSch2.map((row, i) => (
        <tr key={i}>
          <td>
            <input
              className="profile-input py-0"
              placeholder="Activity (e.g., Work Education)"
              value={row.activity}
              onChange={(e) => handleChange2(i, "activity", e.target.value)}
            />
          </td>

          <td>
            <input
              className="profile-input py-0"
              placeholder="A / B / C"
              value={row.grade}
              onChange={(e) => handleChange2(i, "grade", e.target.value)}
            />
          </td>
        </tr>
      ))}

      <tr className='hide-class'>
        <td colSpan={2} className="text-center">
          <button className='profile-btn2' onClick={handleAddRow2}>
            + Add More
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>


</div>
{/* co scholastic area ends */}

<p className='fw-semibold mt-4'>ATTENDANCE :</p>
<div className='table-responsive'>
    <table className="table table-bordered border-dark text-center">
<thead className='para-text'>
    <tr>
    <th>PRESENT DAYS</th>
    <th>ABSENTEES</th>
    <th>LEAVES</th>
    <th>% ATTENDANCE</th>
    </tr>
</thead>

<tbody className='border-dark'>
<tr>
    <td>{presentCount}</td>
    <td>{absentCount}</td>
    <td>{leaveCount}</td>
    <td>{attendancePercent}%</td>
</tr>
</tbody>


</table>
</div>


{/* attendance detail ends */}

<p className='fw-semibold my-4'>Class Teacher's Remarks: <br />Result: <br />Place: Berhampur</p>

<div className='d-flex justify-content-between'>

<p>
  <span className='fw-semibold me-2'>Date</span> : {new Date().toLocaleDateString('en-GB')}</p>
<p className='fw-semibold my-0'>Class Teacher's Signature</p>
<p className='fw-semibold my-0'>Principal's Signature</p>
</div>


<hr />

<div className='text-center'>
<p className='fw-semibold my-0'>Instructions</p>
<p className='my-0 para-text'><span className='fw-semibold'>Grading Scale for Scholastic Areas:</span>  Grades are awarded on a 8-point grading scale as follows-</p>


<div className='row mt-2'>

<div className='col-md-6 col-12 mt-2'>
<table className="table table-bordered border-dark">
<thead className='para-text'>
    <tr>
    <th>MARKS RANGE</th>
    <th>GRADE</th>
    </tr>
</thead>

<tbody className='border-dark'>
<tr>
    <td>91-100</td>
    <td>A1</td>
</tr>

<tr>
    <td>81-90</td>
    <td>A2</td>
</tr>

<tr>
    <td>71-80</td>
    <td>B1</td>
</tr>

<tr>
    <td>61-70</td>
    <td>B2</td>
</tr>
</tbody>


</table>
</div>

<div className='col-md-6 col-12 mt-2'>
<table className="table table-bordered border-dark">
<thead className='para-text'>
    <tr>
    <th>MARKS RANGE</th>
    <th>GRADE</th>
    </tr>
</thead>

<tbody className='border-dark'>
<tr>
    <td>91-100</td>
    <td>A1</td>
</tr>

<tr>
    <td>81-90</td>
    <td>A2</td>
</tr>

<tr>
    <td>71-80</td>
    <td>B1</td>
</tr>

<tr>
    <td>61-70</td>
    <td>B2</td>
</tr>
</tbody>

</table>
</div>
{/* table ends */}


</div>
{/* inner grade ends */}
</div>

</div>
{/* card ends */}



</div>
</section>
    </>
  )
}

export default PrepareReportCard